// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recommendations-bottom-sheet {
  /* Custom styles for recommendations bottom sheet */
}

.recommendations-content {
  
}

.recommendations-toggle-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Desktop styles - hide bottom sheet on desktop */
@media (min-width: 769px) {
  .recommendations-bottom-sheet {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/bottomdrawers/RecommendationsBottomSheet.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;AACrD;;AAEA;;AAEA;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,kDAAkD;AAClD;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".recommendations-bottom-sheet {\n  /* Custom styles for recommendations bottom sheet */\n}\n\n.recommendations-content {\n  \n}\n\n.recommendations-toggle-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Desktop styles - hide bottom sheet on desktop */\n@media (min-width: 769px) {\n  .recommendations-bottom-sheet {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
